export class XylemImage extends Image {
	constructor(options, callBacks) {
		super();

		if (callBacks) {
			if (callBacks.onerror) {
				this.onerror = callBacks.onerror.bind(this);
			}
			if (callBacks.onload) {
				this.onload = callBacks.onload.bind(this);
			}
		}

		if (!options) {
			return;
		}

		if (options.data) {
			for (let property in options.data) {
				if (options.data.hasOwnProperty(property)) {
					this.dataset[property] = options.data[property];
				}
			}
		}

		this.src = options.src;
		this.alt = options.alt;
	}
}
